import type { UseFetchOptions } from 'nuxt/app';
import { refreshTokenUtily } from '#imports';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface fetchOptions<T = any> extends UseFetchOptions<T> {
  ignoreStoreError?: boolean;
}

export default defineNuxtPlugin(async (_nuxtApp) => {
  const { user, loggedIn } = useUserSession();

  const api = $fetch.create({
    onRequest({ options }) {
      if (user.value?.access_token) {
        options.headers.set('Authorization', `Bearer ${user.value.access_token}`);
      }
    },

    async onResponseError({ response, options }) {
      const optionsFetch = options as fetchOptions;

      const store = errorStore();

      const errorId = response._data?.id || response._data?.data.id;

      const ERROR_REFRESH_TOKEN = ['INVALID_TOKEN'];

      if (response.status === 401 && loggedIn.value && ERROR_REFRESH_TOKEN.includes(errorId)) {
        store.ADD_ERROR({ id: 'INVALID_TOKEN' });

        const refreshToken = user.value?.refresh_token;

        if (refreshToken) {
          await refreshTokenUtily(refreshToken);
          return;
        } else {
          // Sem refresh token, redireciona para login
          await navigateTo(useUseRouteCallbackUrl('/signin'));
          return;
        }
      }

      if (optionsFetch.ignoreStoreError) return;

      if (errorId) {
        store.ADD_ERROR({ id: errorId });
        return;
      }

      if (response.status === 400) {
        store.ADD_ERROR({ id: 'BAD_REQUEST' });
        return;
      }

      if (response.status === 404) {
        store.ADD_ERROR({ id: 'NOT_FOUND' });
        return;
      }

      if (response.status === 500) {
        store.ADD_ERROR({ id: 'INTERNAL_SERVER_ERROR' });
        return;
      }
    },
  });

  return {
    provide: {
      api,
    },
  };
});
